module.exports = "## Photo Enlarger\r\n\r\nYou can also make your photos bigger with this tool. Simply select the \"custom size\" option from the Resize drop-down. Enter any dimension you want to enlarge your image to and proceed to save your image. Note: you may lose some quality if you enlarge your photo too much."


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/photo-enlarger.md
// module id = 1179
// module chunks = 0